export default "__VITE_ASSET__DVxj6Dnh__"